import React, { useState, useCallback, useRef } from 'react';
import {
  map as _map,
  isEmpty as _isEmpty,
  last as _last,
  cloneDeep as _cloneDeep,
  find as _find,
  dropRight as _dropRight,
  sortBy as _sortBy,
  isUndefined as _isUndefined,
  findIndex,
  maxBy as _maxBy
} from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import HopperConversation from './HopperConversation';
import { onLogout } from 'redux/UserManagement/UserManagement.action';
import Cookies from 'js-cookie';
import moment from 'moment';
import jwt_decode from 'jwt-decode';
import { updateChatObject2 } from '../redux/H.action';
import { hopperConstants } from '../redux/H.constants';
import { staticQuestionsToAvoid } from '../utility/utility';
import { apiServices } from 'redux/utils/api_services';

const HopperBody = React.forwardRef((props, startHopperConversationInstance) => {
  const {
    channelFilterProps,
    selectedChannels, // name of clicked channel :: array,
    customChatQuery, // chat string :: string
    setSearchPayload, //set question in state to search :: function
    isLoadingResponse,
    setIsLoadingResponse,
    setIsQuestionLoading,
    isQuestionLoading,
    onSendMessage,
    scrollToBottom,
    currencyData,
    setIsDataCheckPassed,
    actionRequiredChannel,
    renderMessageInputLayout,
    currentConv,
    setCurrentConv,
    activeSessionId,
    setActiveSessionId,
    connections,
    setConnections,
    deleteConversation,
    isNeedToShowChannelFilter,
    isOnboardingActive,
    setIsEligibleToTriggerOnboardingMsg,
    openHopprDrawer,
    dashboardMap = {}
  } = props;

  const socketRef = useRef(null);
  const dispatch = useDispatch();
  const [isConnected, setIsConnected] = useState(false);
  const hopperHistoryData = useSelector(state => state?.Hopper?.history);

  // ! we have to remove this dependency from redux. read this from local storage
  const hopperChatData = useSelector(state => state?.Hopper?.config);

  const updateChatObject = useCallback(
    props => {
      const { activeConversation, initialObject, isConnectionClosed, merchantID, setCurrentConv, sessionId } = props;
      let cloned = _cloneDeep(initialObject);
      cloned = [...cloned, activeConversation];
      // TODO: Store it in state if isLoading is false for all conversations
      setCurrentConv(cloned);
      let sessionMap = hopperHistoryData?.sessionMap;
      let sessionObjIndex = sessionMap?.findIndex(item => item.sessionIds.includes(sessionId));
      if (sessionObjIndex === -1) {
        sessionObjIndex = sessionMap?.findIndex(item => item.date === activeConversation?.request_time?.split(' ')[0]);
      }
      if (sessionObjIndex !== -1) {
        const updatedItems = [...hopperHistoryData?.sessionMap];
        let obj = updatedItems[sessionObjIndex];
        if (!obj?.sessionIds?.includes(sessionId)) {
          obj.sessionIds = [sessionId, ...obj?.sessionIds];
          updatedItems[sessionObjIndex] = { ...updatedItems[sessionObjIndex], ...obj };
        }
      } else {
        sessionMap = [
          { date: `${moment().format('YYYY-MM-DD')}`, sessionIds: [sessionId] },
          ...hopperHistoryData?.sessionMap
        ];
      }
      let conversationMap = { ...hopperHistoryData?.conversationMap, [sessionId]: cloned };
      dispatch({
        type: hopperConstants.GET_HOPPER_CONVERSATION_SUCCESS,
        payload: { sessionMap: sessionMap, conversationMap: conversationMap }
      });
      dispatch(updateChatObject2({ merchantID: merchantID, cloned: cloned }));
    },
    [hopperHistoryData]
  );
  React.useImperativeHandle(startHopperConversationInstance[3], () => ({
    updateChatObject
  }));

  // ! Update response in redux
  const onUpdateActiveConversation = useCallback(
    payload => {
      // ! Required props
      // initialObject: payload.initialObject,
      // activeConversation: payload.activeConversation,
      // loadingResponses: payload?.loadingResponses,
      // responses: payload?.responses,
      // currentResponse: payload?.currentResponse,
      // isLoading: payload?.isLoading,
      //isConnectionClosed : payload?.isConnectionClosed

      let clone = payload?.activeConversation;
      clone['loadingResponses'] = payload?.loadingResponses;
      clone['responses'] = payload?.responses;
      clone['currentResponse'] = payload?.currentResponse;
      clone['isLoading'] = payload?.isLoading;
      // TODO: remove replace logic from redux slice.
      updateChatObject({
        activeConversation: clone,
        initialObject: payload.initialObject,
        merchantID: currencyData?.merchantID,
        isConnectionClosed: payload?.isConnectionClosed || false,
        setCurrentConv: setCurrentConv,
        sessionId: payload?.session_id || activeSessionId
      });
    },
    [hopperHistoryData]
  );

  // ! call API once conversation started
  const onStartHopperConversation = useCallback(() => {
    if (!_isEmpty(customChatQuery)) {
      const requestTime = `${moment().format('YYYY-MM-DD HH:mm:ss')}`;

      // * using same session ID for entire conversation
      const socket_id = !_isEmpty(activeSessionId)
        ? activeSessionId
        : `${currencyData?.merchantID}_${currencyData?.userName.split(' ')[0]}_${moment().format(
            'YYYY-MM-DD_HH:mm:ss'
          )}`;
      setActiveSessionId(socket_id);

      let latestDataFromStorage = _cloneDeep(currentConv);
      if (latestDataFromStorage?.data?.is_get_started_loading === false) {
        latestDataFromStorage.data.is_get_started_loading = true;
      }
      let lastStoredHopperData = _cloneDeep(hopperHistoryData?.conversationMap?.[socket_id]) || [];
      let maxObject = _maxBy(lastStoredHopperData, 'conversation_id');
      const conversation_id = maxObject ? maxObject.conversation_id + 1 : 1;

      // ! if all selected OR no channel selected then send channel array as empty in payload
      const channelList =
        channelFilterProps?.allChannels.length === selectedChannels.length || selectedChannels.length === 0
          ? []
          : selectedChannels;

      let finalAnswerList = [];

      setIsLoadingResponse(true);
      setIsEligibleToTriggerOnboardingMsg(false);
      setSearchPayload('');

      //! Response For redux
      let data = {
        conversation_id,
        question_text: customChatQuery,
        conversation_type: 'request',
        request_time: requestTime,
        channels: channelList,
        responses: [],
        loadingResponses: [],
        currentResponse: {},
        currency: currencyData?.countryCode,
        isLoading: true
      };

      //! construct payload for socket
      let payload = {
        session_id: `${socket_id}`,
        conversation_id: `${conversation_id}`,
        request_time: requestTime,
        seller_id: currencyData?.merchantID,
        user_id: currencyData?.userName.split(' ')[0],
        algo: 'Gamma',
        question: customChatQuery,
        currency: currencyData?.currencyCode,
        currency_symbol: currencyData?.currencySymbol,
        isConnectionAborted: false,
        merchant_country: currencyData?.countryName,
        merchant_name: currencyData?.merchantName || ''
      };
      if (isNeedToShowChannelFilter) {
        payload.channels = channelList;
      }

      // ! Making this as static check
      if (staticQuestionsToAvoid.includes(customChatQuery)) {
        payload = {
          ...payload,
          isInitialConversation: true,
          currency_code: currencyData?.currencyCode,
          timezone: currencyData?.timezone
        };
        if (isNeedToShowChannelFilter) {
          payload.initialChannelList = selectedChannels || [];
        }
      }

      // * function Update initial loading response in redux on click of ask button.
      onUpdateActiveConversation({
        session_id: `${socket_id}`,
        initialObject: latestDataFromStorage,
        activeConversation: data,
        loadingResponses: [
          ...data?.loadingResponses,
          {
            session_id: `${socket_id}`,
            context_id: '',
            conversation_id: conversation_id,
            agent: 'user',
            update: 'Analyzing your question',
            answer: '',
            suggested_questions: [],
            status: 'ongoing',
            response_time: requestTime
          }
        ],
        responses: [],
        currentResponse: {},
        isLoading: true
      });

      //! Create a socket connection
      if (!isConnected) {
        if (connections.hasOwnProperty(socket_id)) {
          socketRef.current = connections[socket_id];
        } else {
          socketRef.current = new WebSocket(
            `${apiServices['hopper_ws']}/${socket_id}?token=${Cookies.get('accessToken')}`
          );
          setConnections(prev => ({ ...prev, [socket_id]: socketRef.current }));
        }

        // * Function to start new connection
        socketRef.current.onopen = () => {
          if (process.env.NODE_ENV !== 'production') console.log('😇 Connected to WebSocket server');
          setIsConnected(true);
          sendMessage(payload);
          scrollToBottom();
        };

        // * Function to get messages from socket
        socketRef.current.onmessage = event => {
          const stringifiedData = JSON.parse(event?.data);
          const { status } = stringifiedData;

          scrollToBottom();

          // ! Update active conversation in redux also send final payload to reducer
          if (status === 'ongoing') {
            if (stringifiedData?.agent !== 'user' || !_isEmpty(stringifiedData?.answer)) {
              const isSuggestedQuestion = stringifiedData?.agent === 'question_suggester' ? stringifiedData : {};
              const isNotSuggestedQuestion = stringifiedData?.agent !== 'question_suggester' ? stringifiedData : {};

              // ! Update Redux with latest data
              onUpdateActiveConversation({
                session_id: `${socket_id}`,
                initialObject: latestDataFromStorage,
                activeConversation: data,
                loadingResponses: [...data?.loadingResponses, isNotSuggestedQuestion],
                responses: finalAnswerList || [],
                currentResponse: isSuggestedQuestion,
                isLoading: true
              });
            }
          }

          if (status === 'suggesting_question') {
            setIsQuestionLoading(true);
            // ! Update Redux with latest data
            onUpdateActiveConversation({
              session_id: `${socket_id}`,
              initialObject: latestDataFromStorage,
              activeConversation: data,
              loadingResponses: data?.loadingResponses,
              responses: finalAnswerList || [],
              currentResponse: stringifiedData
            });
          }

          // ! If status is completed OR answer_completed
          if (
            [
              'initial_loading',
              'initial_data_loading',
              'initial_completed',
              'answer_completed',
              'completed',
              'error'
            ].includes(status)
          ) {
            finalAnswerList = [...finalAnswerList, stringifiedData];

            // ! Update Redux with latest data
            onUpdateActiveConversation({
              session_id: `${socket_id}`,
              initialObject: latestDataFromStorage,
              activeConversation: data,
              loadingResponses: [...data?.loadingResponses],
              responses: finalAnswerList,
              currentResponse: {},
              isLoading: false
            });

            // Stop loader for loading messages
            if (status === 'completed') {
              setIsLoadingResponse(false);
              setIsEligibleToTriggerOnboardingMsg(true);
            }
          }

          // ! Construct function if status is completed
          if (['completed', 'initial_completed', 'error'].includes(status)) {
            setIsQuestionLoading(false);
            // Reset loading states
            resetStateAndStatus();

            // Close socket connection
            socketRef.current.close();
          }
        };

        // * Function on close connection
        socketRef.current.onclose = () => {
          if (process.env.NODE_ENV !== 'production') console.log('😩 Disconnected from WebSocket server');
          resetStateAndStatus();
          setConnections(prev => {
            const updatedConnections = { ...prev };
            delete updatedConnections[socket_id];
            return updatedConnections;
          });
        };

        // * Function to handle on error in socket connection
        socketRef.current.onerror = error => {
          if (process.env.NODE_ENV !== 'production') console.error('🤬 WebSocket error:', error);
          const accessToken = Cookies.get('accessToken');
          if (accessToken) {
            const decodedToken = jwt_decode(accessToken);
            let tokenExp = parseInt(decodedToken?.exp);
            // If the token is expired, log the user out.
            if (Math.floor(Date.now() / 1000) > tokenExp) return onLogout();
          }

          resetStateAndStatus();
        };

        // ! Function to reset loading state and empty holding array
        const resetStateAndStatus = () => {
          // Stop loader for suggested question
          setIsQuestionLoading(false);

          // Stop loader for loading messages
          setIsLoadingResponse(false);
          setTimeout(() => setIsEligibleToTriggerOnboardingMsg(false), 2000);

          setIsConnected(false);

          finalAnswerList = [];
        };
      } else {
        sendMessage(payload);
      }
    }
  }, [customChatQuery, channelFilterProps, selectedChannels, hopperHistoryData]);

  // * On send new chat message
  const sendMessage = payload => {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      socketRef.current.send(JSON.stringify(payload)); // Send message as JSON
      if (process.env.NODE_ENV !== 'production') console.log('😍 Message sent:', payload);
    } else {
      if (process.env.NODE_ENV !== 'production') console.warn('😩 WebSocket connection is not open.');
    }
  };

  //! Pass the childFunction to the parent component using ref
  React.useImperativeHandle(startHopperConversationInstance[0], () => ({
    onStartHopperConversation
  }));

  // * Stop socket connection on click of stop button
  const onStopSocketConnection = useCallback(() => {
    if (socketRef.current) {
      setIsConnected(false);
      setIsLoadingResponse(false);
      setIsEligibleToTriggerOnboardingMsg(false);
      let lastStoredHopperData = _cloneDeep(hopperHistoryData?.conversationMap?.[activeSessionId]);
      const conversationId = _last(lastStoredHopperData)?.conversation_id || 0;

      // If the connection is the last one, we need to remove incomplete conversions.
      // We are not removing the entire conversation because the next conversation ID needs to be sent as `+1`.
      // Therefore, we are maintaining the conversation object as {conversation_id: 0}.

      const updatedConversation = _map(lastStoredHopperData, conversation => {
        if (conversation?.conversation_id === conversationId) {
          return {
            conversation_id: conversation?.conversation_id
          };
        }
        return conversation;
      });

      lastStoredHopperData = updatedConversation;
      const isExistingConvAvailable = !_isEmpty(
        _find(updatedConversation, conv => _isUndefined(conv?.update_status) && !_isUndefined(conv?.question_text)) ||
          {}
      );
      deleteConversation(activeSessionId, activeSessionId, conversationId.toString(), isExistingConvAvailable);

      updateChatObject({
        activeConversation: {},
        initialObject: lastStoredHopperData,
        isConnectionClosed: true,
        merchantID: currencyData?.merchantID,
        setCurrentConv: setCurrentConv,
        sessionId: activeSessionId
      });

      // ! if click on stop button in between then send 'isConnectionAborted'
      // ! flag to hopper engine to close connection
      if (!_isEmpty(activeSessionId)) {
        sendMessage({
          session_id: activeSessionId,
          conversation_id: `${conversationId}`,
          seller_id: currencyData?.merchantID,
          user_id: currencyData?.userName.split(' ')[0],
          isConnectionAborted: true
        });
      }

      socketRef.current.close();
      setConnections(prev => {
        const updatedConnections = { ...prev };
        delete updatedConnections[activeSessionId];
        return updatedConnections;
      });
    }
  }, [hopperChatData, hopperHistoryData, activeSessionId]);

  React.useImperativeHandle(startHopperConversationInstance[2], () => ({
    onStopSocketConnection
  }));

  // * Clean up the socket connection when the component unmounts
  // while switching drawer -> modal or modal -> drawer connection is getting closed. so commenting this useeffect
  // useEffect(() => {
  //   return () => {
  //     if (socketRef.current) {
  //       socketRef.current.close();
  //       setIsConnected(false);
  //       setConnections(prev => {
  //         const updatedConnections = { ...prev };
  //         delete updatedConnections[activeSessionId];
  //         return updatedConnections;
  //       });
  //     }
  //   };
  // }, []);

  return (
    <>
      {_isEmpty(currentConv) && (
        <div className='body_container'>
          <div className='body_heading'>{`What can I help you with?`}</div>
          <div className='hopperChatBodyV2_footer v-center'>{renderMessageInputLayout()}</div>
        </div>
      )}

      {/* //! Load conversation from local storage */}
      {
        // !_isEmpty(parsedConversation?.data?.conversations) &&
        !_isEmpty(currentConv) &&
          _map(currentConv, (chatConversation, index) => {
            return (
              <React.Fragment key={index}>
                <HopperConversation
                  userInitial={currencyData?.userName.split('')[0].toUpperCase()}
                  chatConversation={chatConversation}
                  setSearchPayload={setSearchPayload} //set question in state to search :: function
                  isQuestionLoading={isQuestionLoading}
                  isLoadingResponse={isLoadingResponse}
                  onSendMessage={onSendMessage}
                  actionRequiredChannel={actionRequiredChannel}
                  isOnboardingActive={isOnboardingActive}
                  chatConvIndex={index}
                  openHopprDrawer={openHopprDrawer}
                  dashboardMap={dashboardMap}
                />
              </React.Fragment>
            );
          })
      }

      {/* //! Load conversation from redux as live conversation */}
      {/* {!_isEmpty(hopperChatData?.data?.conversations) &&
        _map(hopperChatData?.data?.conversations, chatConversation => {
          return (
            <React.Fragment key={chatConversation?.conversation_id}>
              <HopperConversation
                userInitial={currencyData?.userName.split('')[0].toUpperCase()}
                chatConversation={chatConversation}
                setSearchPayload={setSearchPayload} //set question in state to search :: function
                isQuestionLoading={isQuestionLoading}
              />
            </React.Fragment>
          );
        })} */}
    </>
  );
});

export default HopperBody;
